/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from 'app/app.component';
import { appConfig } from 'app/app.config';
import './app/core/helpers/extensions/string-extension'
import { environment } from '@env/environment';
import { datadogRum } from '@datadog/browser-rum';
import { AppConfigModel, BuildInfoModel } from './app/core/models/shared/shared-models';

bootstrapApplication(AppComponent, appConfig)
    .then(() => {
        const config = environment.appConfig;
        const buildInfo = environment.buildInfo;
        if (isDatadogRUMReady(config, buildInfo)) {
            datadogRum.init({
                applicationId: config.dd_appId,
                clientToken: config.dd_token,
                site: 'us3.datadoghq.com',
                service: config.dd_service,
                env: config.dd_env,
                version: buildInfo.buildNumber,
                sessionSampleRate: 100,
                sessionReplaySampleRate: 20,
                trackBfcacheViews: true,
                trackResources: true,
                trackLongTasks: true,
                trackUserInteractions: true,
                defaultPrivacyLevel: 'mask-user-input'
            });
        }
    })
    .catch((err) => console.error(err));

function isDatadogRUMReady(config: AppConfigModel, buildInfo: BuildInfoModel): boolean {
    let isMaster = buildInfo.sourceBranch === "refs/heads/master";
    let isDdConfigured = ![config.dd_appId, config.dd_token, config.dd_service, config.dd_env, buildInfo.buildNumber]
        .some(v => (v == null || v.trim().length === 0));
    return isMaster && isDdConfigured;
}